module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.label) + _vm._s(this.required !== undefined ? '*' : ''))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": _vm.counter,
      "rules": _vm.couterRules,
      "required": _vm.required,
      "value": _vm.value
    },
    on: {
      "input": _vm.setTexto
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0387ad46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-solo-text-field.vue
// module id = 765
// module chunks = 0